import { DocumentVisibilityTracker } from '@pulse/browser-shared';
import { AnalyticsPlugin } from '@pulse/common';

enum VisibilityState {
    Visible,
    Hidden,
}

class VisibilityChangePlugin implements AnalyticsPlugin {
    visibilityState: VisibilityState = VisibilityState.Visible;

    constructor(private visibility: DocumentVisibilityTracker) {}

    init() {
        this.visibility.onVisibilityChange().subscribe((visible) => {
            this.visibilityState = visible ? VisibilityState.Visible : VisibilityState.Hidden;
        });
    }
}

export { VisibilityChangePlugin, VisibilityState };
